/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { YoutubeIntegrationGetBroadcastsQueryResponse, YoutubeIntegrationGetBroadcastsPathParams, YoutubeIntegrationGetBroadcastsQueryParams, YoutubeIntegrationGetBroadcasts401, YoutubeIntegrationGetBroadcasts403 } from "../models/YoutubeIntegrationGetBroadcasts";
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";
import { youtubeIntegrationGetBroadcasts } from "../axios/youtubeIntegrationGetBroadcasts";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export const youtubeIntegrationGetBroadcastsSuspenseQueryKey = (station: YoutubeIntegrationGetBroadcastsPathParams["station"], params: YoutubeIntegrationGetBroadcastsQueryParams) => ["api-v2", { url: '/youtube-integration/v1/broadcasts/:station', params: {station:station} }, ...(params ? [params] : [])] as const

export type YoutubeIntegrationGetBroadcastsSuspenseQueryKey = ReturnType<typeof youtubeIntegrationGetBroadcastsSuspenseQueryKey>

export function youtubeIntegrationGetBroadcastsSuspenseQueryOptions(station: YoutubeIntegrationGetBroadcastsPathParams["station"], params: YoutubeIntegrationGetBroadcastsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = youtubeIntegrationGetBroadcastsSuspenseQueryKey(station, params)
        return queryOptions<YoutubeIntegrationGetBroadcastsQueryResponse, ResponseErrorConfig<YoutubeIntegrationGetBroadcasts401 | YoutubeIntegrationGetBroadcasts403>, YoutubeIntegrationGetBroadcastsQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return youtubeIntegrationGetBroadcasts(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Computes on-air intervals from stream gaps in the requested window, matches live/ended YouTube videos for the station channel, and returns enriched broadcast rows sorted most-recent first.
 * @summary List on-air broadcasts for a station
 * {@link /youtube-integration/v1/broadcasts/:station}
 */
export function useYoutubeIntegrationGetBroadcastsSuspense<TData = YoutubeIntegrationGetBroadcastsQueryResponse, TQueryKey extends QueryKey = YoutubeIntegrationGetBroadcastsSuspenseQueryKey>(station: YoutubeIntegrationGetBroadcastsPathParams["station"], params: YoutubeIntegrationGetBroadcastsQueryParams, options: 
{
  query?: Partial<UseSuspenseQueryOptions<YoutubeIntegrationGetBroadcastsQueryResponse, ResponseErrorConfig<YoutubeIntegrationGetBroadcasts401 | YoutubeIntegrationGetBroadcasts403>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? youtubeIntegrationGetBroadcastsSuspenseQueryKey(station, params)
         

         const query = useSuspenseQuery({
          ...youtubeIntegrationGetBroadcastsSuspenseQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<YoutubeIntegrationGetBroadcasts401 | YoutubeIntegrationGetBroadcasts403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}